export default __webpack_public_path__ + "0065a218f9120c96fd8d5a03c124bb6c.mp3";